var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "badge badge-dark", staticStyle: { "font-size": "12.8px" } },
    [
      _c("i", { staticClass: "mdi", class: _vm.getIntensityIcon }),
      _vm._v("\n    " + _vm._s(_vm.intensity) + "\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }